<template>
  <a-modal :getContainer="getContainer" v-model:visible="visible" :title="title" @cancel="close" :keyboard="false"
           :maskClosable="true" :footer="null" :afterClose="afterClose">
    <a-spin :spinning="spinning">
      <a-form ref="form" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-item label="角色名称" name="roleName">
          <a-input v-model:value="form.roleName"/>
        </a-form-item>
        <a-form-item label="备注" name="remark">
          <a-input v-model:value="form.remark"/>
        </a-form-item>
      </a-form>
      <div class="form-bootom-button">
        <a-button type="button" @click="close">取消</a-button>
        <a-button type="primary" @click="saveOrgRole" style="margin-left: 10px">确定</a-button>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
import api from '@/api';
import CommonMixin from "@/mixin/CommonMixin";

export default {
  name: 'RoleModal',
  mixins: [CommonMixin],
  data() {
    return {
      visible: false,
      spinning: false,
      title: '',
      form: {},
      rules: {
        roleName: [
          {required: true, message: '请输入角色名称！', trigger: 'blur'},
        ]
      },
    }
  },
  methods: {
    getContainer() {
      return document.getElementById("comptainer_insurance_org_manager");
    },
    close() {
      this.visible = false;
    },
    afterClose() {
      this.$refs.form.clearValidate();
      Object.assign(this.$data, this.$options.data.call(this));
    },
    add() {
      this.visible = true;
      this.title = '新增';
    },
    edit(record) {
      this.visible = true;
      this.title = '编辑';
      this.form = record;
    },
    okCallback() {
      this.$emit('ok');
    },
    formData() {
      return this.form;
    },
    saveOrgRole() {
      let that = this;
      that.$refs.form.validate().then(() => {
        that.spinning = true;
        api.saveOrgRole(that.formData()).then(res => {
          that.spinning = false;
          if (res.code != that.apiStatus.success) {
            that.$message.error(res.message);
            return;
          }
          that.$message.success(that.apiStatus.defaultSuccMsg);
          that.close();
          that.okCallback();
        }).catch(() => {
          that.spinning = false;
          that.$message.error(that.apiStatus.defaultErrMsg);
        });
      });
    }
  }
}
</script>
